<template>
  <div>
    <el-dialog
      title="违章记录"
      :visible.sync="visible"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          v-loading="listLoading"
          :data="dataList"
          border
          fit
          highlight-current-row
        >
          <el-table-column
            label="违章时间"
            prop="happenTime"
            align="center"
            width="180"
          />
          <el-table-column
            label="违章描述"
            prop="content"
            width="260"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="驾驶员"
            prop="driverName"
            align="center"
            width="120"
          />

          <el-table-column
            label="处理状态"
            prop="status"
            width="120"
            align="center"
          >
            <!--  	状态，0：待处理 1：已处理	 -->
            <template slot-scope="scope">
              <div v-if="scope.row.status === 1">
                <el-button type="success" size="small">已处理</el-button>
              </div>
              <div v-else>
                <el-popconfirm
                  title="违章是否已处理？"
                  @confirm="dealIllegalEvent(scope.row)"
                >
                  <el-button type="danger" size="small" slot="reference"
                    >待处理</el-button
                  >
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <el-button
          type="primary"
          @click="addCarViolationRecordsInfoDialogVisible = true"
          >新增违章记录</el-button
        >

        <el-button @click="closeViloationRecordsInfoDialog()">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="新增违章记录"
      :visible.sync="addCarViolationRecordsInfoDialogVisible"
      @close="closeAddCarViolationRecordsInfoDialog()"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="车牌号：">
          {{ this.selectCarInfo.carNum }}
        </el-form-item>

        <el-form-item label="车辆类型：">
          {{ this.selectCarInfo.carTypeName }}
        </el-form-item>

        <el-form-item label="违章日期：">
          <el-date-picker
            v-model="happenTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间(结束时间)"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="违章短信：">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="content"
            style="margin-top: 10px"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="驾驶人：">
          <div style="display: flex; flex-direction: row">
            <el-button @click="openAddPeople()">选择人员</el-button>

            <div
              v-if="this.selectPeopleList.length > 0"
              style="margin-left: 10px"
            >
              {{ this.selectPeopleList[0].id }}-{{
                this.selectPeopleList[0].name
              }}
            </div>
          </div>
        </el-form-item>
      </el-form>

      <div
        style="
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
        "
      >
        <el-button type="primary" @click="addCarViolationRecordsInfoSubmit()"
          >确 定</el-button
        >
        <el-button @click="closeAddCarViolationRecordsInfoDialog()"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <add-people
      :addPeopleVisible="addPeopleDialogVisible"
      dialogTitle="选择司机"
      :peopleList="selectPeopleList"
      :isLimit="true"
      @closeAddPeopleVisible="closeAddPeopleDialog"
      @submitPeople="submitAddPeopleDriver"
    />
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import {
  addIllegal,
  addUsage,
  dealIllegal,
  listPageIllegal,
} from '@/api/equipmentmanagement';
import AddPeople from '@/components/AddPeople/index.vue';

export default {
  name: 'ViolationRecordsInfoDialog',
  components: { AddPeople },
  //违章记录
  props: {
    carViolationRecordsInfoDialogVisible: false,
    selectCarInfo: {},
  },
  watch: {
    carViolationRecordsInfoDialogVisible(val) {
      if (val) {
        //请求接口
        this.getCarViolationRecordsInfo();
      }
    },
  },

  computed: {
    visible: {
      get() {
        return this.carViolationRecordsInfoDialogVisible;
      },
      set(val) {
        if (!val) {
          this.$emit('closeEvent');
        }
      },
    },
  },
  data() {
    return {
      listLoading: false,
      dataList: [],

      addCarViolationRecordsInfoDialogVisible: false,

      happenTime: '',
      content: '',

      addPeopleDialogVisible: false,
      selectPeopleList: [],
    };
  },
  methods: {
    closeViloationRecordsInfoDialog() {
      this.visible = false;
    },
    getCarViolationRecordsInfo() {
      let req = {
        carId: this.selectCarInfo.carId,
        carNum: this.selectCarInfo.carNum,
        carType: this.selectCarInfo.carType,
        current: 1,
        size: Number.MAX_SAFE_INTEGER,
      };

      listPageIllegal(req).then((result) => {
        this.dataList = result.data.data.records;
      });
    },

    addCarViolationRecordsInfoSubmit() {
      if (this.happenTime === '') {
        this.$message.error('请选择违章日期');
        return;
      }
      if (this.content === '') {
        this.$message.error('请选择违章短信');
        return;
      }
      if (this.selectPeopleList.length === 0) {
        this.$message.error('请选择驾驶人');
        return;
      }

      let req = {
        carId: this.selectCarInfo.carId,
        content: this.content,
        driverId: this.selectPeopleList[0].id,
        driverName: this.selectPeopleList[0].name,
        happenTime: this.happenTime,
        status: 0, //状态，0：待处理 1：已处理
      };

      addIllegal(req).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: '提交成功', type: 'success' });

          this.closeAddCarViolationRecordsInfoDialog();
          this.getCarViolationRecordsInfo();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
    closeAddCarViolationRecordsInfoDialog() {
      //清数据
      this.happenTime = '';
      this.content = '';
      this.selectPeopleList = [];

      this.addCarViolationRecordsInfoDialogVisible = false;
    },

    openAddPeople() {
      this.addPeopleDialogVisible = true;
    },

    closeAddPeopleDialog() {
      this.addPeopleDialogVisible = false;
    },
    submitAddPeopleDriver(employeeRoleList) {
      this.selectPeopleList = employeeRoleList;
    },

    dealIllegalEvent(obj) {
      //处理违章车辆
      let req = {
        id: obj.id,
        status: 1, //状态，0：待处理 1：已处理
      };

      // console.log(req)
      dealIllegal(req).then((result) => {
        if (result.data.code === 200) {
          this.$message({ message: '修改成功', type: 'success' });

          this.getCarViolationRecordsInfo();
        } else {
          this.$message.error(result.data.message);
        }
      });
    },
  },
  created() {},
};
</script>
